// src/lib/opportunity/orgFormInstanceClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type {
  OrgFormFilledBlock,
  OrgFormGeneratedOutput,
  OrgFormInstanceListItem,
} from "./orgFormInstanceTypes.js";
import type { OrgFormTemplate } from "./orgFormTemplateTypes.js";

export function listOrgFormInstances() {
  return opportunityFetch<{ ok: true; instances: OrgFormInstanceListItem[] }>(
    "/api/opportunity/form-instance-list",
    { method: "GET" },
  );
}

export function getOrgFormInstance(instanceId: string) {
  const q = new URLSearchParams({ instance_id: instanceId });
  return opportunityFetch<{
    ok: true;
    instance: OrgFormInstanceListItem;
    template: OrgFormTemplate | null;
    blocks: OrgFormFilledBlock[];
  }>(`/api/opportunity/form-instance-list?${q.toString()}`, { method: "GET" });
}

export function createOrgFormInstance(payload: {
  form_template_id: string;
  source_type?: "standalone" | "lead" | "opportunity";
  lead_id?: string | null;
  opportunity_id?: string | null;
}) {
  return opportunityFetch<{ ok: true; instance: OrgFormInstanceListItem }>(
    "/api/opportunity/form-instance-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function saveOrgFormInstanceValues(payload: {
  id: string;
  values?: Array<{ block_id: string; text_value?: string | null; calc_value?: number | null }>;
  doc_variable_values?: Record<string, string>;
  status?: "draft" | "saved";
  use_rep_form_contact?: boolean;
}) {
  return opportunityFetch<{ ok: true; instance: OrgFormInstanceListItem }>(
    "/api/opportunity/form-instance-upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}

export function deleteOrgFormInstance(instanceId: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/form-instance-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: instanceId }),
  });
}

export function listOrgFormGeneratedOutputs(args: {
  formInstanceId: string;
  signMedia?: boolean;
}) {
  const q = new URLSearchParams({ form_instance_id: args.formInstanceId });
  if (args.signMedia) q.set("sign_media", "1");
  return opportunityFetch<{ ok: true; outputs: OrgFormGeneratedOutput[] }>(
    `/api/opportunity/form-generated-list?${q.toString()}`,
    { method: "GET" },
  );
}
